/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetCloudArrowDownloadIcon16Light } from './NetCloudArrowDownloadIcon16Light';
import { NetCloudArrowDownloadIcon16Regular } from './NetCloudArrowDownloadIcon16Regular';
import { NetCloudArrowDownloadIcon16Solid } from './NetCloudArrowDownloadIcon16Solid';
import { NetCloudArrowDownloadIcon20Light } from './NetCloudArrowDownloadIcon20Light';
import { NetCloudArrowDownloadIcon20Regular } from './NetCloudArrowDownloadIcon20Regular';
import { NetCloudArrowDownloadIcon20Solid } from './NetCloudArrowDownloadIcon20Solid';
import { NetCloudArrowDownloadIcon24Regular } from './NetCloudArrowDownloadIcon24Regular';
import { NetCloudArrowDownloadIcon24Solid } from './NetCloudArrowDownloadIcon24Solid';
import { NetCloudArrowDownloadIcon32Regular } from './NetCloudArrowDownloadIcon32Regular';
import { NetCloudArrowDownloadIcon64Regular } from './NetCloudArrowDownloadIcon64Regular';
var sizes = {
    16: {
        light: NetCloudArrowDownloadIcon16Light,
        regular: NetCloudArrowDownloadIcon16Regular,
        solid: NetCloudArrowDownloadIcon16Solid,
    },
    20: {
        light: NetCloudArrowDownloadIcon20Light,
        regular: NetCloudArrowDownloadIcon20Regular,
        solid: NetCloudArrowDownloadIcon20Solid,
    },
    24: {
        regular: NetCloudArrowDownloadIcon24Regular,
        solid: NetCloudArrowDownloadIcon24Solid,
    },
    32: {
        regular: NetCloudArrowDownloadIcon32Regular,
    },
    64: {
        regular: NetCloudArrowDownloadIcon64Regular,
    },
};
export var NetCloudArrowDownloadIcon = forwardRef('NetCloudArrowDownloadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
